import type { ServerErrorMap } from '@hooks/useServerErrors';

/**
 * UI error targets for the user edit form.
 *
 * Field targets match `<form.Field name="X">` in EditUserFields — the
 * useServerErrors hook routes their messages into TanStack form state via
 * setFieldMeta and the existing `<FieldError errors={field.state.meta.errors}/>`
 * renders them.
 */
export type UserErrorTarget =
  | 'name'
  | 'email'
  | 'mobile_number'
  | 'role'
  | 'confirmation_status'
  | 'access_level'
  | 'employment_type'
  | 'nric'
  | 'vehicle_number'
  | 'sling_user_id'
  | 'sling_position_id';

export const USER_SERVER_ERROR_TARGETS: ServerErrorMap<UserErrorTarget> = {
  name: ['name'],
  email: ['email'],
  mobile_number: ['mobile_number'],
  role: ['role'],
  confirmation_status: ['confirmation_status'],
  access_level: ['access_level'],
  employment_type: ['employment_type'],
  nric: ['nric'],
  vehicle_number: ['vehicle_number'],
  'sling_account.sling_user_id': ['sling_user_id'],
  'sling_account.position_id': ['sling_position_id'],
  // Set by the server, never picked; a bad one is only fixable by changing the position.
  'sling_account.location_id': ['sling_position_id'],
};

// No base (non-field) targets today — every attribute UsersController#update
// can reject has a matching form field.
export const USER_BASE_ERROR_TARGETS: readonly UserErrorTarget[] = [];
